
import axios from 'axios';
import { API_URL, getApiHeaders } from "./api.js"

// const checkRequest = requestData => axios.get(
//     `${API_URL}/customer/requests/checkpermission/` + requestData, getApiHeaders()
// );
// const fetchContacts = () => axios.get(
//     `${API_URL}/global/contacts`, getApiHeaders()
// );

const fetchOrders = postData => axios.post(
    `${API_URL}/customer/orders`, postData, getApiHeaders()
);

const fetchOrderDetails = orderId => axios.get(
    `${API_URL}/customer/orders/details/` + orderId, getApiHeaders()
);

const fetchOrderHistory = orderId => axios.get(
    `${API_URL}/customer/orders/history/` + orderId, getApiHeaders()
);

export{
    fetchOrders,
    fetchOrderDetails,
    fetchOrderHistory,
}